module.exports = __webpack_public_path__ + "img/calc.0ab03801.jpg";